export default "./images/ENInfoNoCompassFix2.jpg";